import React, { Fragment } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Dialog, Table } from "../../layout";
import { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "../../App";
import { DropLi } from "../../hooks";
import { useTranslation } from "react-i18next";
import InputSwitch from "../../controls/InputSwitch";
import { action, controller, Server } from "../../api/Server";
import { ToFormData } from "../../hooks/Method";
import ResetPasswordForm from "./resetPassword/ResetPasswordForm";
import ActionComp from "./ActionComp";
import HeaderComp from "./HeaderComp";

const Users = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setLoader, selStore, setPageTitle, authUser } =
    useContext(AppContext);
  const { Gender, Role } = DropLi();
  const [updateUserId, setUpdateUserId] = useState();
  const [showResetPassForm, setShowResetPassForm] = useState(false);
  const [csvHeader, setCsvHeader] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [access, setAccess] = useState({});
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    if (
      authUser &&
      authUser.featuresAccess &&
      authUser.featuresAccess.userAccess
    )
      setAccess({ ...authUser.featuresAccess.userAccess });
    return () => {};
  }, [authUser]);

  useEffect(() => {
    setPageTitle && setPageTitle(t("users"));
    setCsvHeader([
      { key: "fullName", label: t("fullName") },
      { key: "userName", label: t("userName") },
      { key: "dob", label: t("dateOfBirth") },
      { key: "gender", label: t("gender") },
      { key: "phone", label: t("phone") },
      { key: "role", label: t("userRole") },
      { key: "address", label: t("address") },
    ]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selStore) {
      setLoader(true);
      const onComplete = (res) => {
        setLoader(false);
        res.status === 200 &&
          setTblData(
            res.result.map((user) => {
              var gender = Gender.find((j) => j.id === user.gender);
              var role = Role.find((j) => j.id === user.role);
              return {
                ...user,
                gender: gender ? gender.label : "",
                role: role ? role.label : "",
              };
            })
          );
      };
      Server(controller.User + action.GetAllByStore).getById(
        selStore,
        onComplete
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selStore]);

  const handleAddEdit = (val) => {
    navigate(`user-form/${val.id || ""}`);
  };

  const handleActive = (id) => {
    Server(controller.User + action.ChangeActiveStatus).post(
      ToFormData({
        userId: id,
        dateTime: new Date().toISOString(),
      }),
      (res) => {
        res && res.status === 200
          ? setTblData([
              ...tblData.map((j) =>
                j.id === id ? { ...j, isActive: res.result.isActive } : j
              ),
            ])
          : setAlert({
              isOpen: true,
              type: "error",
              title: t("error"),
              subTitle: res.msg,
            });
      }
    );
  };

  return (
    <>
      <Table
        ActionComp={(param) => (
          <ActionComp
            {...{
              param,
              access,
              handleAddEdit,
              setAlert,
              setTblData,
              setUpdateUserId,
              setShowResetPassForm,
            }}
          />
        )}
        HeaderComp={() => (
          <HeaderComp {...{ access, handleAddEdit, tblData, csvHeader }} />
        )}
        tblHead={[
          { id: "actions", label: t("actions") },
          { id: "active", label: t("active") },
          { id: "user", label: t("user") },
          { id: "contact", label: t("contact") },
          { id: "canAccess", label: t("canAccess") },
          { id: "address", label: t("address") },
        ]}
        tblData={tblData.map((user) => {
          return {
            ...user,
            active: access.isHaveActivatiInactiveAccess ? (
              <InputSwitch
                checked={user.isActive}
                onChange={() => handleActive(user.id)}
              />
            ) : user.isActive ? (
              "Active"
            ) : (
              "Inactive"
            ),
            idSearch: `id ${user.id}`,
            user: (
              <div className="d-grid">
                <span className="fw-5">{user.fullName}</span>
                <span className="fs-12">
                  <span className="fw-5">
                    {t("id")}: {user.id}
                  </span>
                  &nbsp; | &nbsp;
                  <span className="fw-5">{user.userName}</span>
                  &nbsp; | &nbsp;
                  <span className="fw-6 primary-color">{user.role}</span>
                </span>
              </div>
            ),
            contact: (
              <div className="d-grid ">
                {user.email && (
                  <a
                    className="fs-14 primary-color c-pointer mb-3"
                    href={`mailto:${user.email}`}
                  >
                    ✉️ {user.email}
                  </a>
                )}
                {user.phone && (
                  <a
                    className="fs-14 primary-color c-pointer"
                    href={`tel:${user.phone}`}
                  >
                    📞 {user.phone}
                  </a>
                )}
              </div>
            ),
            canAccess: (
              <div className="d-flex g-5">
                {user.stores &&
                  user.stores.map((store, ind) => (
                    <Fragment key={ind}>
                      <span className="fw-5">
                        {store.store && store.store.storeName}
                      </span>
                      {user.stores.length > ind + 1 && " | "}
                    </Fragment>
                  ))}
              </div>
            ),
            address: (
              <div className="d-grid fs-14">
                <span>
                  {user.city} {user.city && ", "} {user.state} {user.zip}
                </span>
                <span>{user.address}</span>
              </div>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />

      {/* Change Access */}
      {updateUserId && (
        <Dialog show={showResetPassForm} onClose={false} maxWidth="xs">
          <ResetPasswordForm
            key={showResetPassForm ? new Date() : "hidden"}
            userId={updateUserId}
            setShowForm={setShowResetPassForm}
          />
        </Dialog>
      )}
    </>
  );
};

export default Users;
